import React from "react";
import { zl } from "../../../functions/utilities.js";

const MieszkaniecWydrukFooter = props => {

    const { tablicaCzynszeAkt, procent } = props;

    return (
        <tr>
            <td
                style={{
                    border: '1px solid black',
                    textAlign: 'right',
                    padding: '1mm 2mm',
                    fontWeight: '600'
                }}
                colSpan={5}
            >
                Razem zaliczka:
            </td>
            <td 
                style={{
                    border: '1px solid black', 
                    padding: '1mm',
                    textAlign: 'right',
                    fontWeight: '600'
                }}
            >
                {zl(tablicaCzynszeAkt?.czynsz_na_msc + (procent?.saldo || 0))}
            </td>
        </tr>
    )
}

export default MieszkaniecWydrukFooter;